<template>
  <v-dialog width="350px" persistent v-model="editDialog" class="signIn">
    <v-list-tile slot="activator" class="">
        <v-list-tile-action>
            <v-icon left>lock_open</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Sign In
        </v-list-tile-content>
    </v-list-tile>
    <v-card>
      <v-container>
        <v-layout justify-end row wrap>
          <v-flex xs1 class="mb-2">
            <v-icon depressed class="cyan--text" @click="editDialog = false">close</v-icon>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex xs12 class="text-xs-center mb-4">
            <img src="/static/img/victorium_logo.png" />
          </v-flex>
        </v-layout>
        <v-layout row justify-center v-if="error">
          <v-flex xs12 sm6>
            <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
          </v-flex>
        </v-layout>
        <v-layout row justify-center>
          <v-flex xs10>
            <p class="grey--text">Administrator Login</p>
            <form @submit.prevent="onSignin">
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    name="email"
                    label="Email Address"
                    id="email"
                    v-model="email"
                    type="email"
                    required>
                  </v-text-field>
                  <!-- <v-icon class="iconPlaceholder">email</v-icon> -->
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    name="password"
                    label="Password"
                    id="password"
                    v-model="password"
                    type="password"
                    required>
                  </v-text-field>
                  <!-- <v-icon class="iconPlaceholder">lock_outline</v-icon> -->
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>                    
                  <v-btn xs4 class="grey lighten-1 white--text" depressed @click.native="editDialog = false">
                    Cancel
                  </v-btn>                     										
                  <v-btn xs4 type="submit" :disabled="loading" :loading="loading" depressed class="cyan white--text">
                    Log In
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span> 
                  </v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-flex>
        </v-layout>        
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      editDialog: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    onSignin () {
      // Vuex
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
      this.$store.dispatch('loadTrials')
      this.$router.push('/')
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
<style scoped lang="scss">
.flex.xs12{
  position: relative;
}
.iconPlaceholder{
  position: absolute;
  top: 0;
  left: 0;
}
.signIn {
  width: 100%;
  display: block;
  .list__tile{
    padding: 0;
  }
}

</style>



// WEBPACK FOOTER //
// MenuSignIn.vue?d4e2a608